module.exports = __webpack_public_path__ + "img/Frame 5123.170650ef.jpg";